import SettingsPage from "./SettingsPage";

export default [
    {
        path: "/settings",
        name: "settings",
        component: SettingsPage
    }
];